import ask from '@/utils/http'

export default {
  // 获取公众号用户分析
  getUserAnalysis: (params = {}) => ask.get(`/backstage/getUserAnalysis`, params),
}



// WEBPACK FOOTER //
// ./src/api/weChat.js